function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 1.091v14.311a1 1 0 00-.43.097l-3.79 1.802a1 1 0 01-1.42-1.032l.543-4.161a1 1 0 00-.266-.817L.752 8.244a1 1 0 01.543-1.671l4.125-.77a1 1 0 00.695-.504l2.007-3.686A1 1 0 019 1.091z"
})));